// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fedex-mfa-step__hints[data-v-3872a82c]{background:#f4f4f7;border-radius:8px;padding:10px 16px;color:#333}.fedex-mfa-step__radios[data-v-3872a82c] .v-icon{color:#b4b4c4!important}.fedex-mfa-step__radios[data-v-3872a82c] .v-item--active .v-icon{color:#36134a!important}", ""]);
// Exports
module.exports = exports;
